import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
}

const DabdoobSolidIcon: React.FC<Props> = ({ fill = "#F27D23", stroke = "#F27D23", ...props }) => {
  return (
    <svg
      {...props}
      width="37"
      height="35"
      viewBox="0 0 37 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.87248 11.8265C2.84463 11.8265 1.58285 11.6459 0.835505 11.057C-0.0526079 10.4228 -0.0960816 9.2449 0.0871306 8.24757C0.321062 7.11478 0.882085 5.93985 1.53627 4.9365C2.005 4.22992 2.57088 3.58856 3.2183 3.03013C3.54539 2.80337 3.87248 2.52845 4.19957 2.34985C6.11553 1.08161 8.59149 0.443482 9.99611 2.75822L10.0893 2.89367C13.1262 2.07895 17.425 1.94249 20.0883 3.21073C20.1825 2.34985 19.9951 0.85586 19.7612 0C20.8367 0.634119 22.8458 2.49133 23.9668 4.62044C24.1914 4.7439 24.4257 4.84992 24.6676 4.9375C24.4813 3.84987 24.4813 2.76324 24.9015 1.99266C25.5557 0.769572 27.3785 0.36221 28.6869 0.407361C30.6028 0.407361 32.4246 1.22309 33.7795 2.58163C34.9016 3.75956 35.7887 5.20841 36.0692 6.83986C36.2099 7.60943 36.2099 9.01312 35.5081 9.55694C34.4803 10.2814 33.0788 10.6446 31.7238 10.8703C31.7704 10.9155 31.817 11.0068 31.8636 11.0519C32.4246 11.7764 32.8925 12.5921 33.3127 13.3596C34.7122 15.858 35.6468 18.6222 35.8808 21.4748C36.1613 24.3283 35.5061 27.0002 33.6377 29.2197C30.0842 33.523 23.2174 34.9769 17.8442 34.9769C12.0032 34.9317 5.274 33.3916 2.19045 28.0919C1.25886 26.4614 0.788927 24.6042 0.741313 22.7019C0.648154 18.9383 1.7702 15.0423 3.87248 11.8265ZM10.7414 5.80641L11.2082 5.6258C11.0219 5.48935 10.8345 5.39904 10.6907 5.30874L10.7414 5.80641Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default DabdoobSolidIcon;
